import { Badge } from 'antd';
import { useTranslate } from '@tolgee/react';
import { AssitantRealtimeStatus } from 'services/api/dashboard';
import { SwitchLineDetailButton } from './SwitchLineDetail';

interface OnlineStatusCellProps {
  status: AssitantRealtimeStatus;
  userId: string;
}

export const OnlineStatusCell = (props: OnlineStatusCellProps) => {
  const { status, userId } = props;

  const { t } = useTranslate();

  const lowText = status.toLowerCase();
  if (lowText === 'online') {
    return (
      <div className="flex items-center gap-2">
        <Badge color="green" text={t('status.online')} />
        <SwitchLineDetailButton userId={userId} />
      </div>
    );
  }
  if (lowText === 'offline') {
    return (
      <div className="flex items-center gap-2">
        <Badge color="var(--fett-text-quaternary)" text={t('status.offline')} />
        <SwitchLineDetailButton userId={userId} />
      </div>
    );
  }
  if (lowText === 'hangup') {
    return (
      <div className="flex items-center gap-2">
        <Badge color="#f2a200" text={t('status.hangup')} />
        <SwitchLineDetailButton userId={userId} />
      </div>
    );
  }

  return <>{t('shopee.UNKNOWN')}</>;
};
